import { render, staticRenderFns } from "./AddModuleDialog.vue?vue&type=template&id=a565263e"
import script from "./AddModuleDialog.vue?vue&type=script&lang=js"
export * from "./AddModuleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports